import type { AdminProfileHistory } from './admin-profile-history.model';

export function transformAdminProfileHistory(
  profileHistory: AdminProfileHistory,
): AdminProfileHistory {
  return {
    id: profileHistory.id,
    userId: profileHistory.userId,
    fieldType: profileHistory.fieldType,
    fieldValue: profileHistory.fieldValue,
    updatedAt: profileHistory.updatedAt * 1000, // Convert to milliseconds
    notes: profileHistory.notes,
  };
}
